import React from "react";
import { tickerData } from "../data/mock";
import { TrendingUp, TrendingDown } from "lucide-react";

const MarketTicker = () => {
  // Double the data for seamless infinite scroll
  const doubled = [...tickerData, ...tickerData];

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[rgb(17,17,19)] border-b border-[rgb(63,63,63)] overflow-hidden h-10">
      <div className="flex items-center h-full animate-ticker">
        {doubled.map((item, i) => (
          <div
            key={`${item.name}-${i}`}
            className="flex items-center gap-2 whitespace-nowrap px-6 h-full"
          >
            <span className="w-2 h-2 rounded-full bg-[rgb(74,222,128)] animate-pulse flex-shrink-0" />
            <span
              className="text-white text-xs font-semibold tracking-wide"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              {item.name}
            </span>
            <span className="text-[rgb(63,63,63)]">//</span>
            <span
              className="text-[rgb(161,161,170)] text-[10px] tracking-wider"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item.meta}
            </span>
            <TrendingUp size={12} className="text-[rgb(218,255,1)]" />
            <span
              className="text-[rgb(218,255,1)] text-[11px] font-semibold tracking-wide"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item.status}
            </span>
            <span className="text-[rgb(63,63,63)] mx-3">||</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker-scroll 30s linear infinite;
          width: max-content;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default MarketTicker;
